module.exports = __webpack_public_path__ + "img/hockey-stick-puck.71d9f995.svg";